import { MedicalDataAccessAuthorization } from '@dreryk/egabinet-patient-frontend-api';

import { EditIcon, Link } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';
import { MedicalDataAccessAuthorizationOpenFormAction } from '../MedicalDataAccessAuthorizationModal/MedicalDataAccessAuthorizationOpenFormAction';

import { useMedicalDataAccessAuthorizationUpdateCommand } from './ModifyMedicalDataAccessAuthorizationAction.hooks';
import { mapMedicalDataAccessAuthorizationToFormBean } from './ModifyMedicalDataAccessAuthorizationAction.utils';

type ModifyMedicalDataAccessAuthorizationActionProps = {
   readonly data: MedicalDataAccessAuthorization;
};

const ModifyMedicalDataAccessAuthorizationAction = (
   props: ModifyMedicalDataAccessAuthorizationActionProps
): JSX.Element => {
   const { executeAsync: modifyMedicalDataAccessAuthorization } = useMedicalDataAccessAuthorizationUpdateCommand(
      props.data.id
   );
   const initialValues = mapMedicalDataAccessAuthorizationToFormBean(props.data);

   return (
      <MedicalDataAccessAuthorizationOpenFormAction
         initialValues={initialValues}
         modalTitle={patientConsentsAndAuthorizationsTranslationKeys.authorizations.modifyAuthorization}
         onSubmit={modifyMedicalDataAccessAuthorization}
         render={(openModal) => <Link testId={'modifyAuthorization'} onClick={openModal} icon={<EditIcon />} />}
      />
   );
};

export { ModifyMedicalDataAccessAuthorizationAction };
